export enum ArticleType {
  SALE = "SaleAccommodationArticle",
  RENTAL = "RentalAccommodationArticle"
}

export type ArticleUrlData = {
  __typename: ArticleType;
  id: string;
  slug: string;
}

export const buildSearchUrl = (type: ArticleType | "sold"): string => {
  switch (type) {
    case ArticleType.SALE:
      return "/sales/properties/";
    case "sold":
      return "/sales/history/";
    case ArticleType.RENTAL:
    default:
      return "/rentals/properties/";
  }
}

export const buildArticleUrl = (data: ArticleUrlData) =>
  `${buildSearchUrl(data.__typename)}${data.slug}?refId=${data.id}`;
